<template>
    <div class="upload-container">
      <alert
        v-if="alertCtrl.show"
        :closable="true"
        :type="alertCtrl.type"
        @on-close="alertCtrl.show = false"
      >
        <div v-html="alertCtrl.text"></div>
      </alert>

      <div class="image-preview">
        <div
        class="preview"
        :style="`background: url('${item.preview}') no-repeat center;`"
        v-for="(item, index) in previewImages"
        :key="index"
      >
          <div class="sending" v-if="item.sending">
            Enviando...
          </div>
          <!-- <button class="remove" @click="removePreview(index)" :disabled="item.sending" v-if="!item.sended"><span>&times;</span></button> -->
        </div>
      </div>

      <div class="image-preview">

        <div
          class="preview"
          :style="`background: url('${item.urls['150x150']}') no-repeat center;`"
          v-for="(item, index) in uploadedImages"
          :key="index"
        >
          <button
            class="remove"
            @click="removeImage(index)"
            :disabled="item.sending"
            v-if="!item.sended"
          >
            <span>&times;</span>
          </button>
          <div class="coverimage" v-if="item.id">
            <label class="setcoverradio">
              <input type="radio" name="cover" :checked="item.cover || item.coverImageId" @click="setCover(index)">
              Capa
            </label>
          </div>
          <!-- <div class="sended verde-1"  v-if="item.sended">
            Enviado com sucesso! {{item.sended}}
          </div> -->
          <button
            class="legend"
            :class="{ 'has-legend': item.caption }"
            @click="LegendModalShow(index)"
            v-if="EnableCaption"
          >
            Legenda
          </button>
        </div>

        <modal
          title="Dê uma Legenda para a foto"
          :show-footer="true"
          :is-show="showLegendModal"
          ok-text="Salvar"
          :on-ok="saveLegend"
          @close="showLegendModal = false"
        >

          <div class="control">
            <input type='text' class='input' placeholder='Descreva sua foto' v-model="currentLegendText">
          </div>
        </modal>

        <form enctype="multipart/form-data" novalidate :disabled="disabledInSend">
          <input type="file" multiple @change="filesChange($event)"
            :accept="accepttypes" class="input-file" :disabled="disabledInSend">
        </form>
      </div>

  </div>
</template>

<script>
import { bytesToSize, sizeToBytes } from '../helpers'

export default {

  name: 'ImageUpload',

  props: {
    accepttypes: {
      type: String,
      required: true
    },
    max: {
      type: Number,
      default: 0
    },
    fileSizeLimit: {
      type: String
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: false
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false
    },
    onSubmit: {
      type: Function,
      required: true
    },
    onSetCover: {
      type: Function,
      required: false
    },
    EnableCaption: {
      type: Boolean,
      required: false,
      default: true
    },
    onSetLegend: {
      type: Function,
      required: true
    },
    onRemoveItem: {
      type: Function,
      required: true
    },
    images: {
      type: Array,
      required: false
    }
  },

  data () {
    return {
      showLegendModal: false,
      currentLegendIndex: -1,
      currentLegendText: '',
      previewImages: [],
      uploadedImages: [],
      disabledInSend: false,
      alertCtrl: {
        show: false,
        type: 'info',
        text: ''
      }
    }
  },

  methods: {
    checkFileSizeLimit (fileSize) {
      if (this.fileSizeLimit.length > 0) {
        let limit = sizeToBytes(this.fileSizeLimit)
        let fsize = fileSize
        if (fsize > limit) {
          return false
        }
      }
      return true
    },
    setCover (index) {
      if (this.onSetCover) {
        this.onSetCover(index)
      }
    },
    disableSetCover (item) {
      if (item.coverImageId) {
        return true
      }
      return false
    },
    save () {
      let bulk = []

      if (this.previewImages.length > 0) {
        this.disabledInSend = true
      }
      for (let i = 0; i < this.previewImages.length; i++) {
        let formdata = new FormData()
        for (let key in this.previewImages[i]) {
          this.previewImages[i].sending = true
          if (key === 'caption') {
            formdata.append(key, this.previewImages[i][key])
          }
          if (key === 'file') {
            formdata.append(key, this.previewImages[i][key], this.previewImages[i][key].name)
          }
        }
        bulk.push(formdata)
      }
      this.onSubmit(bulk)
    },
    filesChange (event) {
      let fieldList = event.target.files
      let total = fieldList.length
      if (total > this.max) {
        total = this.max
        this.alertCtrl = {
          type: 'warning',
          show: true,
          text: 'Você atingiu o limite máximo de imagens para este Local. Para enviar mais imagens, apague algumas.'
        }
      }
      for (let i = 0; i < total; i++) {
        if (this.checkFileSizeLimit(fieldList[i].size)) {
          // console.log(fieldList[i])
          this.previewImages.push(
            { preview: URL.createObjectURL(fieldList[i]),
              file: fieldList[i],
              name: fieldList[i].name,
              sending: false,
              sended: false
            }
          )
        } else {
          this.alertCtrl.text += `<p>A imagem ${fieldList[i].name} (${bytesToSize(fieldList[i].size)}) não pode ser enviada porque ultrapassa o limite de ${this.fileSizeLimit}.</p>`
          if (i === total - 1) {
            this.alertCtrl.show = true
            this.alertCtrl.type = 'warning'
          }
        }
      }
      this.save()
    },
    removePreview (index) {
      this.previewImages.splice(index, 1)
    },
    removeImage (index) {
      if (this.onRemoveItem) {
        this.onRemoveItem(index)
      }
    },
    LegendModalShow (index) {
      this.showLegendModal = true
      this.currentLegendIndex = index
      this.currentLegendText = this.uploadedImages[index].caption
    },
    saveLegend () {
      this.uploadedImages[this.currentLegendIndex].caption = this.currentLegendText
      this.onSetLegend(this.currentLegendText, this.uploadedImages[this.currentLegendIndex].id)
      this.currentLegendIndex = -1
      this.currentLegendText = ''
      this.showLegendModal = false
      // editImageCaption({ caption: this.currentLegendText }, this.solutionId, this.uploadedImages[this.currentLegendIndex].id )
      // .then(
      //   success => {
      //     this.currentLegendIndex = -1
      //     this.currentLegendText = ""
      //     this.showLegendModal = false
      //   }
      // )
    },
    showSendedMsg (i) {
      this.uploadedImages[i].sended = true
      setTimeout(() => {
        this.uploadedImages[i].sended = false
      }, 1500)
    }
  },

  created () {
    if (this.images) {
      this.uploadedImages = this.images
    }
  },

  watch: {
    images (value) {
      if (value.length !== this.uploadedImages) {
        this.uploadedImages = value
        this.previewImages.forEach((preview, index) => {
          let indexArray = []
          value.forEach((item, idx) => {
            if (preview.name === item.originalFileName) {
              indexArray.push(index)
            }
            if (item.coverImageId) {
              this.disableSetCover(this.uploadedImages[idx])
            }
            for (let i = indexArray.length; i >= 0; i--) {
              // console.log(indexArray[i])
              this.removePreview(indexArray[i])
            }
          })
        })
        this.disabledInSend = false
      }
    },
    max (value) {
      if (value === 0) {
        this.disabledInSend = true
        this.alertCtrl = {
          type: 'warning',
          show: true,
          text: 'Você atingiu o limite máximo de imagens e documentos para esta Solução. Para enviar mais imagens, apague algumas imagens ou documentos.'
        }
      }
      if (value > 0) {
        this.alertCtrl.show = false
        this.disabledInSend = false
      }
    }
  }

}
</script>

<style lang="scss">
.image-preview {
  display: flex;
  flex-flow: row wrap;
  margin-bottom: 30px;
  .preview {
    background-size: cover !important;
    height: 150px;
    position: relative;
    margin: 15px;
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: 150px;
    max-width: 150px;
    .remove {
      outline: none;
      display: flex;
      color: #fff;
      width: 30px;
      height: 30px;
      background: #EF545C;
      font-weight: bold;
      position: absolute;
      top: -15px;
      right: -15px;
      font-size: 18px;
      border: none;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      padding: 0;
      border-radius: 50px;
      z-index: 100;
      cursor: pointer;
    }
    .legend {
      background: transparent;
      border: 2px solid #fff;
      color: #fff;
      border-radius: 3px;
      position: absolute;
      bottom: 10px;
      left: 10px;
      outline: none;
      cursor: pointer;
      &.has-legend {
        border-color: #26B2BF;
        background: #26B2BF;
      }
    }
    .sending,
    .sended {
      background: rgba(255,255,255, .3);
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      color: #fff;
      z-index: 10;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      transition: all ease .2s;
    }
    .sended {
      background: rgba(0,0,0,.5);
    }
    .coverimage {
      color: #fff;
      position: absolute;
      font-size: 12px;
      top: 5px;
      left: 5px;
      label.setcoverradio {
        input[type="radio"] {
          &:before {
            border-radius: 0;
            border-color: #fff;
            background: transparent;
          }
          &:after {
            background: #fff;
            border-radius: 0;

          }
        }
      }
    }
  }
  form {
    max-width: 150px;
    height: 150px;
    margin: 10px;
    flex-grow: 1;
    flex-shrink: 0;
    flex-basis: 150px;
    background: url('../assets/imgs/input-file-add.png') no-repeat center;
    position: relative;
    &[disabled] {
      opacity: 0.4;
    }
    .input-file {
      opacity: 0;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ImageUpload.vue